<template>
<div>
  <nav
    class="navbar-default navbar-static-side"
    role="navigation"
    v-if="user"
  >
    <div class="sidebar-collapse">
      <ul class="nav metismenu" id="side-menu" v-if="user">
        <li class="nav-header">
          <div class="dropdown profile-element">
            <!-- <h2 class="block m-t-xs font-bold text-white">Frotix Testar</h2> -->
            <img
              src="../../../assets/less/patterns/frotix-logo-menu.png"
              alt=""
              width="180"
              height="120"
            >
          </div>

          <div class="logo-element">
            <img
              src="../../../../public/img/icons/favicon-32x32.png"
              alt=""
            >
          </div>
        </li>

        <SidebarNavigation
          v-for="(navigation, key) in menu"
          :key="key"
          :navigation="navigation"
          :menu="menu"
          :user="user"
        />
      </ul>
    </div>
  </nav>
</div>
</template>

<script>
import SidebarNavigation from '@/components/layout/sidebar/SidebarNavigation'

export default {
  name: 'Sidebar',
  props: {
    menu: {
      type: Array,
      required: true
    },
    user: {
      required: true
    }
  },
  components: {
    SidebarNavigation
  }
}
</script>
